var map = {
	"./components/Footer.i18n.ts": 7754,
	"./components/Header.i18n.ts": 3328,
	"./pages/AIFamily.i18n.ts": 615,
	"./pages/About.i18n.ts": 4218,
	"./pages/CorePeople.i18n.ts": 3937,
	"./pages/DigitalTalent.i18n.ts": 4371,
	"./pages/Home.i18n.ts": 6008,
	"./pages/JoinFutureWorld.i18n.ts": 6930,
	"./pages/PersonalizedService.i18n.ts": 4906,
	"./pages/ProjectCooperation.i18n.ts": 105,
	"./pages/Resources.i18n.ts": 1698,
	"./pages/resources/ContentHub.i18n.ts": 383
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5278;